import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1196e309"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "page-container"
};
const _hoisted_2 = { class: "flex flex-column gap-3" };
const _hoisted_3 = { class: "flex flex-column gap-3 align-content-start" };
const _hoisted_4 = { class: "grid" };
const _hoisted_5 = { class: "col-12 lg:col-6 flex flex-column gap-2" };
const _hoisted_6 = { class: "flex flex-row gap-2" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { class: "grid" };
const _hoisted_9 = { class: "col-9 flex flex-column gap-3" };
const _hoisted_10 = { style: { "float": "left" } };
const _hoisted_11 = ["src"];
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = { key: 1 };
const _hoisted_14 = { class: "col-3 px-3" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h5", null, "Resources", -1));
import { computed, onBeforeMount, ref, } from "vue";
import { getCatalogCardById } from "@/repositories/catalog-card.repository";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { hasMorePrivileges, Roles } from "@/entities/user.entity";
import Tag from "primevue/tag";
import OneDeskLinks from "@/components/molecules/OneDeskLinks.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CardDetailsPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const catalogCard = ref({});
        const cardId = computed(() => route.params.cardId?.toString());
        const currentUserRights = computed(() => store.getters.adminRoles);
        const currentUserCanEditCard = computed(() => currentUserRights.value.some(role => hasMorePrivileges(role, Roles.CatalogAdmin)));
        onBeforeMount(async () => {
            await getCardById();
        });
        const getCardById = async () => {
            if (cardId.value)
                catalogCard.value = await getCatalogCardById(cardId.value);
        };
        const onEditCardClick = () => {
            if (cardId.value) {
                router.push({
                    name: "CardDetailsEdit",
                    params: { cardId: cardId.value },
                });
            }
        };
        return (_ctx, _cache) => {
            return (catalogCard.value.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createVNode(_unref(Tag), {
                                            icon: "pi pi-globe",
                                            severity: "secondary",
                                            value: catalogCard.value.scope
                                        }, null, 8, ["value"]),
                                        _createVNode(_unref(Tag), {
                                            icon: "pi pi-users",
                                            severity: "secondary",
                                            value: catalogCard.value.audience
                                        }, null, 8, ["value"])
                                    ]),
                                    _createElementVNode("h1", null, _toDisplayString(catalogCard.value.title), 1),
                                    (currentUserCanEditCard.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            _createVNode(OneDeskButton, {
                                                class: "mt-2",
                                                icon: "pi pi-pencil",
                                                label: "Edit",
                                                onClick: onEditCardClick
                                            })
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_10, [
                                        (catalogCard.value.imageUri)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                width: "400",
                                                height: "250",
                                                class: "image-bloc",
                                                src: catalogCard.value.imageUri,
                                                loading: "lazy"
                                            }, null, 8, _hoisted_11))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", null, [
                                        (catalogCard.value.content)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                innerHTML: catalogCard.value.content,
                                                class: "text-justify"
                                            }, null, 8, _hoisted_12))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_13, "No content"))
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                                _hoisted_15,
                                _createVNode(OneDeskLinks, {
                                    links: catalogCard.value.links
                                }, null, 8, ["links"])
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
